import { createAsyncThunk } from "@reduxjs/toolkit";
import { postDataWrapper } from "../../../lib/axios";

export interface IForgotPasswordSlice {
  email: string;
}

export const forgotPasswordFetch = createAsyncThunk<
  IForgotPasswordSlice,
  IForgotPasswordSlice
>("forgotPassword/forgotPasswordFetch", async (data, thunkAPI) => {
  try {
    const response: any = await postDataWrapper("auth/forgotPassword", {
      email: data.email,
    });
    return response.data;
  } catch (error: any) {
    console.log(error);
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
